export const MODAL_NAME = "ProjectMilestoneTrackerModal";
